(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('purchase-order', {
			parent : 'entity',
			url : '/purchase-order?page&sort',
			data : {
				authorities : [ 'ROLE_USER' ],
				pageTitle : 'pharmaPortalApp.purchaseOrder.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/purchase-order/purchase-orders.html',
					controller : 'PurchaseOrderController',
					controllerAs : 'vm'
				}
			},
			params : {
				page : {
					value : '1',
					squash : true
				},
				sort : {
					value : 'id,asc',
					squash : true
				}
			},
			resolve : {
				pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
					return {
						page : PaginationUtil.parsePage($stateParams.page),
						sort : $stateParams.sort,
						predicate : PaginationUtil.parsePredicate($stateParams.sort),
						ascending : PaginationUtil.parseAscending($stateParams.sort)
					};
				} ],
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('purchaseOrder');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('purchase-order-detail', {
			parent : 'entity',
			url : '/purchase-order/{id}',
			data : {
				authorities : [ 'ROLE_USER' ],
				pageTitle : 'pharmaPortalApp.purchaseOrder.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/purchase-order/purchase-order-detail.html',
					controller : 'PurchaseOrderDetailController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('purchaseOrder');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'PurchaseOrder', function($stateParams, PurchaseOrder) {
					return PurchaseOrder.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'purchase-order',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		});
	}
})();